module.exports = __webpack_public_path__ + "static/firstfathersdayvest-fba3ce94465ccc9e72497a2bc4353295.jpeg";